import { Textarea, Text, Flex } from '@mantine/core';
import { PortalButton } from 'components/Button/PortalButton';
import { useAppContext } from 'context/hooks';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BsCheck2 } from 'react-icons/bs';
import { formatDate } from 'utils/dates';
import { DocumentIdProps } from 'models/general';
import { useGetWorklistRecord } from 'hooks/api/worklist/useGetWorklistRecord';
import { useUpdateWorklistNote } from 'hooks/api/worklist/useUpdateWorklistNote';

export const DrawerNote = ({ documentId }: DocumentIdProps) => {
  const { data: document, isPending } = useGetWorklistRecord({ documentId });
  const { t } = useTranslation();
  const [notesText, setNotesText] = useState<string>('');
  const { mutate: updateNote } = useUpdateWorklistNote();
  const { currentUser } = useAppContext();

  const saveNote = () => {
    updateNote({
      documentId,
      userId: currentUser?.user.id,
      noteId: document?.notes?.[0]?.id,
      text: notesText,
    });
  };

  if (isPending) {
    return null;
  }

  return (
    <>
      <Flex justify={'flex-end'}>
        <Text c={'var(--mantine-color-dimmed)'}>
          {document?.notes?.[0]?.updateTimestamp &&
            t('note_updated_label', {
              date: `${formatDate({ timestamp: new Date(document?.notes?.[0]?.updateTimestamp), formatWithTime: true })}`,
            })}
          {document?.notes?.[0]?.userName &&
            ` ${t('username_updated_label', { username: document?.notes?.[0]?.userName })}`}
        </Text>
      </Flex>

      <Textarea
        defaultValue={document?.notes?.[0]?.text}
        onChange={(event) => setNotesText(event.currentTarget.value)}
        my={'md'}
        autosize
        minRows={3}
        placeholder={t('notes_add_label')}
        w={'100%'}
        maxLength={250}
      />

      <PortalButton label={t('save_note_label')} Icon={BsCheck2} onClick={() => saveNote()} />
    </>
  );
};
